import React, { Component, HTMLAttributes } from "react";

export default class Main extends Component<HTMLAttributes<HTMLElement>> {
  render() {
    return <main {...this.props}>{this.props.children}</main>;
  }
}
